import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'react-motion-drawer';
// import SearchIcon from 'react-icons/lib/fa/search';
import ProfilePropType from '../../proptypes/profile';
import Styles from './styles';
import TopBar from '../TopBar';
import AppDrawer from '../AppDrawer';
import UserDrawer from '../UserDrawer';
// import Input from '../UIKit/Input';

class EditorLayout extends React.Component {
  constructor() {
    super();
    this.state = {
      leftDrawerOpened: false,
      rightDrawerOpened: false,
    };

    this.onProjectClick = this.onProjectClick.bind(this);
  }

  onProjectClick(props) {
    this.setState({ leftDrawerOpened: false });
    this.props.onProjectClick(props);
  }

  render() {
    return (
      <div style={Styles.wrapper}>
        <TopBar
          profile={this.props.profile}
          onUserClick={() => {
            this.setState({ rightDrawerOpened: true });
          }}
          onHamburgerClick={() => {
            this.setState({ leftDrawerOpened: true });
          }}
          innerStyle={{ justifyContent: 'flex-start' }}
        >
          {this.props.toolbar}
          {/* <Input style={Styles.searchBar} accessory={<SearchIcon style={Styles.searchBarIcon} />} /> */}
        </TopBar>
        <Drawer
          {...Styles.leftDrawer}
          open={this.state.leftDrawerOpened}
          onChange={open => this.setState({ leftDrawerOpened: open })}
        >
          <AppDrawer
            projects={this.props.projects}
            onProjectClick={this.onProjectClick}
            match={this.props.match}
          />
        </Drawer>
        <Drawer
          right
          {...Styles.rightDrawer}
          open={this.state.rightDrawerOpened}
          onChange={open => this.setState({ rightDrawerOpened: open })}
        >
          <UserDrawer
            profile={this.props.profile}
            organizations={this.props.organizations}
            onLogoutClick={this.props.onLogoutClick}
            onOrganizationClick={this.props.onOrganizationClick}
            currentOrganization={this.props.currentOrganization}
          />
        </Drawer>
        {this.props.children}
      </div>
    );
  }
}

EditorLayout.propTypes = {
  children: PropTypes.element,
  profile: ProfilePropType,
  organizations: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      text: PropTypes.string,
      id: PropTypes.string,
    }),
  ),
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      text: PropTypes.string,
      id: PropTypes.string,
    }),
  ),
  onLogoutClick: PropTypes.func,
  onOrganizationClick: PropTypes.func,
  currentOrganization: PropTypes.string,
  onProjectClick: PropTypes.func,
  toolbar: PropTypes.node,
};

EditorLayout.defaultProps = {
  children: null,
  profile: PropTypes.object,
  organizations: [],
  projects: [],
  onLogoutClick: () => {},
  onOrganizationClick: () => {},
  currentOrganization: '',
  onProjectClick: () => {},
  toolbar: null,
};

export default EditorLayout;



// WEBPACK FOOTER //
// ./src/components/EditorLayout/index.js